export default __webpack_public_path__ + "static/media/Kothian Breastplate.4f6993fe.jpg";